import { Injectable } from "@angular/core";
import { AnnouncementStore } from "./announcement.store";
import { OrwiService } from "../orwi.service";
import { AnnouncementModel } from "../dto/announcement.model";
import { GlobalService } from "../global.service";
import { NewsDetailComponent } from "src/app/components/news-detail/news-detail.component";

@Injectable({
  providedIn: "root",
})
export class AnnouncementService {
  storeId: string = "61757166bcd20b2a905f910b";
  constructor(
    private os: OrwiService,
    private announcementStore: AnnouncementStore,
    private glb: GlobalService
  ) { }

  fetchAnnouncements() {

    return new Promise(async (resolve, reject) => {

      if (this.announcementStore.getValue().announcement) {
        return resolve(this.announcementStore.getValue().announcement)
      }
      this.os
        .serviceRequest("/api/feed/getNews", {
          storeId: this.storeId,
          skip: 0,
          limit: 1000,
        })
        .subscribe((o: any) => {
          if (o.response) {
            const announcementList: any = Object.assign(o?.response);
            this.announcementStore.update({
              announcement: announcementList,
            });
            return resolve(announcementList);
          }
          reject(o?.error?.code);
        });
    });
  }

  seletcannouncement(item: AnnouncementModel) {
    this.announcementStore.update({
      selectedAnnouncement: item,
    });

    this.glb.openModal({
      component: NewsDetailComponent,
      cssClass: 'news-detail'
    })
  }

  nextAnnouncement() {
    if(!this.announcementStore.getValue().selectedAnnouncement){
      return
    }
    const announcementList = this.announcementStore.getValue().announcement;
    const selectedAnnouncement = this.announcementStore.getValue().selectedAnnouncement;
    const index = announcementList.findIndex((x) => x.id === selectedAnnouncement.id);
    if(index + 1 === announcementList.length){
      this.closeAnnouncement()
    }else{
      this.announcementStore.update({
        selectedAnnouncement: announcementList[index + 1],
      });
    }
  }

  prevAnnouncement() {
    if(!this.announcementStore.getValue().selectedAnnouncement){
      return
    }
    const announcementList = this.announcementStore.getValue().announcement;
    const selectedAnnouncement = this.announcementStore.getValue().selectedAnnouncement;
    const index = announcementList.findIndex((x) => x.id === selectedAnnouncement.id);
    if( index - 1 < 0){
      this.closeAnnouncement()
    }else{
      this.announcementStore.update({
        selectedAnnouncement: announcementList[index - 1],
      });
    }
  }

  closeAnnouncement() {
    this.glb.closeModal()
    this.announcementStore.update({
      selectedAnnouncement:null,
    });
  }
}
